
import { supabase } from './supabaseClient';
import { ClientePerfil, ClienteEndereco } from '../types';

/**
 * SQL PARA CLIENTES (Execute no SQL Editor do Supabase):
 * 
 * CREATE TABLE IF NOT EXISTS public.clientes_perfis (
 *     id uuid REFERENCES auth.users(id) ON DELETE CASCADE PRIMARY KEY,
 *     nome text NOT NULL,
 *     whatsapp text,
 *     created_at timestamptz DEFAULT now()
 * );
 * 
 * CREATE TABLE IF NOT EXISTS public.clientes_enderecos (
 *     id uuid DEFAULT gen_random_uuid() PRIMARY KEY,
 *     cliente_id uuid REFERENCES public.clientes_perfis(id) ON DELETE CASCADE,
 *     titulo text NOT NULL,
 *     endereco text NOT NULL,
 *     bairro_id uuid NOT NULL,
 *     ponto_referencia text,
 *     created_at timestamptz DEFAULT now()
 * );
 */

export const customerService = {
  async signUp(email: string, pass: string, nome: string, whatsapp: string) {
    const { data, error } = await supabase.auth.signUp({
      email,
      password: pass,
      options: { data: { nome, whatsapp, type: 'customer' } }
    });
    if (error) throw error;
    
    if (data.user) {
      await supabase.from('clientes_perfis').upsert({
        id: data.user.id,
        nome,
        whatsapp
      });
    }
    return data.user;
  },

  async signIn(email: string, pass: string) {
    const { data, error } = await supabase.auth.signInWithPassword({ email, password: pass });
    if (error) throw error;
    return data.user;
  },

  async signOut() {
    await supabase.auth.signOut();
  },

  async getProfile() {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return null;

    const { data: profile } = await supabase
      .from('clientes_perfis')
      .select('*')
      .eq('id', user.id)
      .maybeSingle();

    return profile ? { ...profile, email: user.email } : null;
  },

  async getAddresses() {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return [];

    const { data } = await supabase
      .from('clientes_enderecos')
      .select('*')
      .eq('cliente_id', user.id);
    
    return data || [];
  },

  async saveAddress(address: Partial<ClienteEndereco>) {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) throw new Error("Usuário não logado");

    const payload = { ...address, cliente_id: user.id };
    if (address.id) {
      return await supabase.from('clientes_enderecos').update(payload).eq('id', address.id);
    }
    return await supabase.from('clientes_enderecos').insert([payload]);
  }
};
